import { useState } from 'react';
import Link from 'next/link';
import { LogoMartins } from '@assets/svgs';
import { FooterWrap } from './Footer.styles';
import { MenuWrap } from '../Fblog.styles';
import Modal from '@components/Modal';
import Menu from '@components/Menu/index';

type FooterProps = {
  subscribe?: boolean;
  subscribeText?: string;
  instagram?: boolean;
  isClass?: string;
};

const Footer = ({
  subscribe,
  subscribeText,
  instagram,
  isClass
}: FooterProps) => {
  const [isModalopen, setIsmodalopen] = useState(false);
  const whatAppmsg =
    'Hi George Martins,%0a%0aI would like to talk about my project with you. Could we have a chat about it, please?%0aThank you!%0a%0aMy name:%0aMy number:';
  return (
    <>
      <FooterWrap className={isClass}>
        <div className="menu_footer">
          <MenuWrap>
            <Menu showCopywritingMenu />
          </MenuWrap>
        </div>
        <p style={{ textTransform: 'initial' }}>
          {subscribe && (
            <span onClick={() => setIsmodalopen(true)}>SUBSCRIBE</span>
          )}
          <Link
            href={`https://www.linkedin.com/company/themartinshouse`}
            target="_blank"
            rel="noopener"
          >
            LINKEDIN
          </Link>
          {/* @themartinshouse{' '} */}
          {!instagram && (
            <Link
              href={`https://www.instagram.com/thehouseofmartins`}
              target="_blank"
              rel="noopener"
            >
              INSTAGRAM
            </Link>
          )}
          <Link
            href={`https://www.threads.com/@thehouseofmartins?xmt=AQF0ItFCR-oTVDep3jNdgJjJXqwoE7Twm_hJIFyeWr9YTC4`}
            target="_blank"
            rel="noopener"
          >
            THREADS
          </Link>
          <Link
            href={`https://www.tiktok.com/@thehouseofmartins`}
            target="_blank"
            rel="noopener"
          >
            TIKTOK
          </Link>
          <Link
            href={`https://medium.com/@themartinshouse`}
            target="_blank"
            rel="noopener"
          >
            MEDIUM
          </Link>
          {/* <Link
            href={`https://themartinshouse.substack.com/`}
            target="_blank"
            rel="noopener"
          >
            SUBSTACK
          </Link> */}
          {/* <Link
            href={`https://api.whatsapp.com/send?phone=+447502816932&text=${whatAppmsg}`}
          >
            CONTACT ME
          </Link> */}
        </p>
        <p
          style={{
            marginTop: '10px',
            textAlign: 'center',
            paddingLeft: '10px',
            paddingRight: '10px'
          }}
        >
          © The Martin’s House.
        </p>
        {/* <LogoMartins width={55} height={50} color="#000" /> */}
      </FooterWrap>
      {isModalopen && (
        <Modal
          newsModal
          subscribeText={subscribeText}
          addStyle="1px solid #eee"
          onClose={() => setIsmodalopen(false)}
        />
      )}
    </>
  );
};

export default Footer;
